import { motion } from 'motion/react'

interface Option<T extends string> {
  value: T
  label: string
}

export function Segmented<T extends string>({
  options,
  value,
  onChange,
  layoutId,
  label,
  className = '',
}: {
  options: Option<T>[]
  value: T
  onChange: (value: T) => void
  layoutId: string
  label: string
  className?: string
}) {
  return (
    <div className={`segmented ${className}`} role="tablist" aria-label={label}>
      {options.map((option) => {
        const active = option.value === value
        return (
          <button
            key={option.value}
            type="button"
            role="tab"
            aria-selected={active}
            className={`segmented-item ${active ? 'is-active' : ''}`}
            onClick={() => onChange(option.value)}
          >
            {active ? (
              <motion.span
                layoutId={layoutId}
                className="segmented-indicator"
                transition={{ type: 'spring', stiffness: 420, damping: 34 }}
              />
            ) : null}
            <span className="segmented-label">{option.label}</span>
          </button>
        )
      })}
    </div>
  )
}
